import React from "react";
import { useTranslation } from "react-i18next";
import {
  Panel,
  PanelTitle,
  Table,
  Td,
  Bodyrow,
  CountBadge,
  EmptyState,
  Scroll,
  SortLabel,
} from "./dashboardTable";

export const PopularBalls = ({
  title = "Popular Balls",
  dashboard_data,
  popularBallSort,
  sortByName,
  sortByWeight,
  sortByBalls,
}) => {
  const { t } = useTranslation();

  const sortedData = dashboard_data.popular_balls?.sort((a, b) => {
    if (popularBallSort.name !== 0) {
      return popularBallSort.name >= 0
        ? a.manufacturer.toUpperCase() + a.ball_name.toUpperCase() >
          b.manufacturer.toUpperCase() + b.ball_name.toUpperCase()
          ? 1
          : -1
        : a.manufacturer.toUpperCase() + a.ball_name.toUpperCase() >
          b.manufacturer.toUpperCase() + b.ball_name.toUpperCase()
        ? -1
        : 1;
    } else if (popularBallSort.weight !== 0) {
      return popularBallSort.weight >= 0
        ? Number(a.weight) > Number(b.weight)
          ? 1
          : -1
        : Number(a.weight) > Number(b.weight)
        ? -1
        : 1;
    } else if (popularBallSort.balls !== 0) {
      return popularBallSort.balls >= 0
        ? a.total * 1 > b.total * 1
          ? 1
          : -1
        : a.total * 1 > b.total * 1
        ? -1
        : 1;
    }
  });

  return (
    <Panel>
      <PanelTitle>{title}</PanelTitle>
      {!sortedData || sortedData.length === 0 ? (
        <EmptyState>{t("message.info.no_data", { defaultValue: "No data" })}</EmptyState>
      ) : (
        <Scroll>
          <Table>
            <thead>
              <tr>
                <SortLabel
                  label={t("general.manufacturer_and_name")}
                  sort={popularBallSort.name}
                  onSort={sortByName}
                />
                <SortLabel
                  label={t("general.weight")}
                  sort={popularBallSort.weight}
                  onSort={sortByWeight}
                />
                <SortLabel
                  label={t("general.balls")}
                  sort={popularBallSort.balls}
                  onSort={sortByBalls}
                  align="right"
                />
              </tr>
            </thead>
            <tbody>
              {sortedData.map(
                ({ manufacturer, ball_name, weight, total }, idx) => (
                  <Bodyrow key={idx}>
                    <Td>
                      <strong>{manufacturer}</strong>: {ball_name}
                    </Td>
                    <Td>{weight}</Td>
                    <Td align="right">
                      <CountBadge>{total}</CountBadge>
                    </Td>
                  </Bodyrow>
                )
              )}
            </tbody>
          </Table>
        </Scroll>
      )}
    </Panel>
  );
};
